module.exports = __webpack_public_path__ + "img/PR.36b5f035.svg";